import { useEffect, useState } from 'react'
import Vimeo from '@u-wave/react-vimeo'
import { Link, navigate } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { dotPath } from 'ramdasauce'

import { useStyles } from './styles'
import { Text } from 'components/atoms'
import { ROUTES } from 'utils/constants'

export const VimeoPlayer = ({ data, queue }) => {
  const classes = useStyles()

  const [hasEnded, setHasEnded] = useState(false)
  const [isCanceled, setIsCanceled] = useState(false)
  const [countdown, setCountdown] = useState(8)

  const upNext = dotPath('upNextVideos', queue)[0]

  useEffect(() => {
    if (isCanceled) {
      return countdown
    }
    if (hasEnded && countdown > 0) {
      setTimeout(() => {
        setCountdown(countdown - 1)
      }, 1000)
    } else if (hasEnded && countdown === 0) {
      navigate(`${ROUTES.EPISODE}${dotPath('urlSlug.current', upNext)}`)
    }
  }, [hasEnded, countdown, isCanceled, upNext])

  const renderUpNext = (videos) => {
    return videos.map((vid) => {
      return (
        <Link
          to={`${ROUTES.EPISODE}${dotPath('urlSlug.current', vid)}`}
          className={classes.upNext}
          key={vid.id}
        >
          <GatsbyImage
            image={getImage(dotPath('thumbnail.asset', vid))}
            className={classes.upNextImage}
            alt={dotPath('title', vid)}
          />
          <div className={classes.upNextTextBlock}>
            <Text tag="p" size="body13" className={classes.upNextCategory}>
              {dotPath('category', vid)}
            </Text>
            <Text tag="h1" size="body15" className={classes.upNextTitle}>
              {dotPath('title', vid)}
            </Text>
            <Text tag="h1" size="body14">
              {dotPath('interviewee', vid)}
            </Text>
          </div>
        </Link>
      )
    })
  }

  const autoplayTile = () => {
    return (
      <div className={classes.autoplayScreen}>
        <Text size="body16" className={classes.countdown}>
          Up next in {countdown}
        </Text>
        <div className={classes.autoplay}>
          <GatsbyImage
            image={getImage(dotPath('thumbnail.asset', upNext))}
            alt={dotPath('title', upNext)}
            className={classes.autoplayThumbnail}
          />
          <Text size="body16">{dotPath('title', upNext)}</Text>
        </div>
        <div className={classes.buttons}>
          <button className={classes.button} onClick={handleAutoplayCancel}>
            <Text size="body16">Cancel</Text>
          </button>
          <Link
            className={classes.button}
            to={`${ROUTES.EPISODE}${dotPath('urlSlug.current', upNext)}`}
          >
            <Text size="body16">Play</Text>
          </Link>
        </div>
      </div>
    )
  }

  const handleEnd = () => {
    setHasEnded(true)
  }

  const handleAutoplayCancel = () => {
    setIsCanceled(true)
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <div className={classes.columnWrapper}>
          <div className={classes.playerWrapper}>
            <Vimeo
              video={dotPath('vimeoId', data)}
              className={classes.video}
              width="100%"
              height="auto"
              color="eea900"
              showPortrait={false}
              showByline={false}
              showTitle={false}
              onEnd={handleEnd}
              autoplay={true}
            />
            {hasEnded && autoplayTile()}
          </div>
          <div className={classes.textBlock}>
            <Text tag="p" size="body8" className={classes.category}>
              {dotPath('category', data)}
            </Text>
            <Text tag="h1" size="header2" className={classes.title}>
              {dotPath('title', data)}
            </Text>
            <Text tag="h1" size="body11" className={classes.interviewee}>
              {dotPath('interviewee', data)}
            </Text>
          </div>
        </div>
        <div className={classes.upNextWrapper}>
          <Text tag="p" size="body12" className={classes.upNextTitle}>
            MORE EPISODES:
          </Text>
          <Text tag="p" size="body10" className={classes.upNextSubtitle}>
            Up Next:
          </Text>
          {renderUpNext(dotPath('upNextVideos', queue))}
        </div>
      </div>
    </div>
  )
}
